// What a campaign sends through, and where that is decided.
//
// A campaign's channel is its `type`, fixed when the campaign is created — by the Campaigns page tab
// it was created from. The setup wizard shows it and never changes it. That used to be a choice made
// again on the wizard's second step, which offered SMS from a WhatsApp tab and, because nothing sent
// a `type` at all, stored every campaign as the backend's old default of 'sms'.
//
// Anything that is not 'sms' reads as WhatsApp: it is the one campaign channel that ships, and the
// legacy types ('ad', 'video', 'email') predate channels altogether.

export type Channel = 'sms' | 'whatsapp';

/** The channel for a campaign created outside a channel tab, e.g. from the media library. */
export const DEFAULT_CAMPAIGN_CHANNEL: Channel = 'whatsapp';

export const channelOfCampaign = (campaign?: { type?: string | null } | null): Channel =>
  (campaign?.type === 'sms' ? 'sms' : 'whatsapp');

/** A `?channel=` value, trusted only when it names a real channel. */
export const parseChannel = (value?: string | null): Channel =>
  (value === 'sms' || value === 'whatsapp' ? value : DEFAULT_CAMPAIGN_CHANNEL);

/** How a campaign's type reads to a person. CSS `capitalize` made these "Whatsapp" and "Sms". */
export const channelLabel = (type?: string | null): string => {
  if (type === 'whatsapp') return 'WhatsApp';
  if (type === 'sms') return 'SMS';
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
};
